import { bookingBrandFontFamilyVar, teboxDesignSystem } from '../../styles/tebox-booking';
import type { BookingBrandColors } from '../../utils/booking-brand-colors';
import type { ShopPublicPaymentMethod } from '../../services/shop';

type Props = {
  methods: ShopPublicPaymentMethod[];
  selectedCode?: string;
  onSelect: (code: string) => void;
  brandColors: BookingBrandColors;
  disabled?: boolean;
  selectableCodes?: Set<string>;
  emptyMessage?: string;
};

export function ShopPaymentMethodSelector({
  methods,
  selectedCode,
  onSelect,
  brandColors,
  disabled = false,
  selectableCodes,
  emptyMessage = 'No payment methods are enabled for the online shop. Configure them in admin settings.',
}: Props) {
  if (!methods.length) {
    return (
      <p
        style={{
          fontFamily: bookingBrandFontFamilyVar,
          fontSize: teboxDesignSystem.typography.caption.fontSize,
          color: brandColors.secondaryColor,
          margin: 0,
        }}
      >
        {emptyMessage}
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {methods.map((method) => {
        const selected = selectedCode === method.code;
        const methodDisabled =
          disabled || (selectableCodes != null && !selectableCodes.has(method.code));
        return (
          <button
            key={method.id}
            type="button"
            disabled={methodDisabled}
            onClick={() => onSelect(method.code)}
            style={{
              fontFamily: bookingBrandFontFamilyVar,
              fontSize: teboxDesignSystem.typography.body.fontSize,
              fontWeight: 500,
              padding: '10px 14px',
              borderRadius: brandColors.borderRadius,
              border: selected
                ? `2px solid ${brandColors.buttonColor}`
                : `1px solid ${brandColors.borderColor}`,
              backgroundColor: selected
                ? `color-mix(in srgb, ${brandColors.buttonColor} 8%, #FFFFFF)`
                : '#FFFFFF',
              color: brandColors.textColor,
              cursor: methodDisabled ? 'not-allowed' : 'pointer',
              opacity: methodDisabled ? 0.55 : 1,
            }}
          >
            {method.name}
          </button>
        );
      })}
    </div>
  );
}

export default ShopPaymentMethodSelector;
